/**
 * --------------------------------------------------------------------------
 * CoreUI PRO data-grid util/debounce.ts
 * License (https://coreui.io/pro/license/)
 * --------------------------------------------------------------------------
 */

export const debounce = <Args extends unknown[]>(
  callback: (...args: Args) => void,
  delay: number
): ((...args: Args) => void) => {
  let timeout: ReturnType<typeof setTimeout> | undefined

  return (...args: Args) => {
    clearTimeout(timeout)
    timeout = setTimeout(() => callback(...args), delay)
  }
}
